import { RootState } from 'handlers';

export const getReapplyData = ({ reapplyData }: RootState) => reapplyData;

export const getReapplyDisplayData = ({ reapplyData }: RootState) => {
  if (!reapplyData.data) return undefined;

  return {
    ...reapplyData.data,
    ...reapplyData.updatedFields,
    address: {
      ...reapplyData.data.address,
      ...reapplyData.updatedFields.address,
    },
  };
};
